export const getDomainPrefix = (): string =>
  typeof window === 'undefined'
    ? ''
    : window.location.hostname
      ? window.location.hostname.split('.')[0].toLowerCase()
      : '';

export const devHostHint = (): string =>
  process.env.NODE_ENV !== 'production' ? ' In development, use a branded host like loop-optimise.localhost:3000.' : '';
